<div class="divider desktop"></div>
<div class="tabs">
  <lib-reading-group-book-info [bookInfo]="bookInfo">
    <button class="create-group-button" (click)="_onCreateGroupButtonClick()">
      <sui-icon name="플러스"></sui-icon>
      <span>새 그룹책 만들기</span>
    </button>
  </lib-reading-group-book-info>
</div>
<div class="tab-content">
  <div class="group-description">
    <img
      src="assets/images/group-selection-image.png"
      alt="함께읽기 가이드 이미지"
    />
    <div class="group-description-text">
      <p class="group-description-text-title">
        그룹책으로 함께읽기를 시작하세요.
      </p>
      <p class="group-description-text-description" *ngIf="!allowedSingleMode">
        혼자만의 독서를 원한다면 뷰어 안에서 ‘나의책 보기'로 변경하세요.
      </p>
      <p class="group-description-text-description" *ngIf="allowedSingleMode">
        여전히 혼자읽기를 원하신다면?
        <b (click)="_onSingleModeButtonClick()"
          >혼자읽기(나의책 보기) 바로가기
        </b>
      </p>
    </div>
  </div>
  <div class="divider-phone"></div>
  <div class="search-controls">
    <form class="search-bar" (ngSubmit)="_onSearchBarSubmit()">
      <div class="prefix-icon">
        <sui-icon name="검색"></sui-icon>
      </div>
      <input
        placeholder="그룹책 별명을 입력해 주세요."
        [(ngModel)]="_searchKeyword"
        name="searchKeyword"
        enterkeyhint="search"
      />
      <button
        *ngIf="_searchKeyword"
        type="button"
        (click)="_onClearSearchKeywordButtonClick()"
        class="clear-button"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.99999 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 7.99999 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 7.99999 16ZM8.04193 7.29066L10.6607 4.67188L11.3678 5.37898L8.74903 7.99777L11.3708 10.6196L10.6637 11.3267L8.04193 8.70487L5.37821 11.3686L4.6711 10.6615L7.33482 7.99777L4.67411 5.33705L5.38121 4.62995L8.04193 7.29066Z"
            fill="#CCCCCC"
          />
        </svg>
      </button>
    </form>
    <div class="search-options">
      <select
        sui-select
        [(ngModel)]="_orderBy"
        (ngModelChange)="_onSearchOptionsChange()"
      >
        <option *ngFor="let option of _orderByOptions" [ngValue]="option[0]">
          {{ option[1] }}
        </option>
      </select>
      <sui-checkbox>
        즐겨읽는 그룹책만 보기
        <input
          type="checkbox"
          [(ngModel)]="_likeOnly"
          (ngModelChange)="_onSearchOptionsChange()"
        />
      </sui-checkbox>
    </div>
  </div>
  <div
    class="groups"
    #groupList
    [class.scrolled]="_isScrolled"
    [class.is-loading]="_isLoading"
    [class.is-empty]="_groups && _groups.length === 0"
  >
    <div class="loader" *ngIf="_isLoading"><sui-loader></sui-loader></div>
    <ng-container *ngIf="!_isLoading">
      <div class="group-list-item" *ngFor="let group of _groups; index as i">
        <lib-reading-group-list-item
          [group]="group"
          [invitedGroupId]="invitedGroupId"
          (groupDetailsButtonClick)="_onGroupDetailsButtonClick(i)"
          (groupExited)="_onGroupExited()"
          (likeStateChanged)="_onLikeStateChanged(group.id)"
        >
          <button
            *ngIf="
              group.status === _JoinStatus.joined ||
              group.status === _JoinStatus.owned
            "
            class="group-item-button"
            varSize="medium40"
            sui-box-button
            (click)="_onEnterGroupButtonClick(group.id)"
          >
            그룹책 읽기
          </button>

          <button
            *ngIf="
              group.type !== 'private' &&
              group.status !== _JoinStatus.joined &&
              group.status !== _JoinStatus.owned
            "
            class="group-item-button"
            varSize="medium40"
            sui-solid-button
            (click)="_onEnterGroupButtonClick(group.id, i)"
            [disabled]="group.status === _JoinStatus.kicked"
          >
            그룹책 열어보기
          </button>
          <button
            *ngIf="
              group.type === 'private' &&
              group.status !== _JoinStatus.joined &&
              group.status !== _JoinStatus.owned
            "
            class="group-item-button"
            varSize="medium40"
            sui-solid-button
            (click)="_onJoinGroupButtonClick(i)"
            [disabled]="
              group.status === _JoinStatus.kicked ||
              group.max_member_count === group.member_count
            "
          >
            그룹책 비밀번호 입력
          </button>
        </lib-reading-group-list-item>
      </div>
      <div *ngIf="_groups" (libIntersectionListener)="_onScrollEnd()"></div>

      <div
        class="placeholder"
        *ngIf="_groups && _groups.length === 0 && !_likeOnly"
      >
        <p>일치하는 그룹책이 없습니다.</p>
      </div>
      <div
        class="placeholder"
        *ngIf="_groups && _groups.length === 0 && _likeOnly"
      >
        <p>즐겨읽기 한 그룹책이 없습니다.</p>
      </div>
    </ng-container>
  </div>
  <div class="mobile-buttons" *ngIf="!_isKeyboardVisible">
    <button
      varSize="large:medium54:medium40"
      sui-box-button
      (click)="_onCreateGroupButtonClick()"
    >
      새 그룹책 만들기
    </button>
  </div>
</div>
